import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["backdrop", "flash", "modal"];

  connect() {
    this.flashTargets.forEach((flash) => {
      setTimeout(() => flash.remove(), 5000);
    });
  }

  showModal(event) {
    event.preventDefault();

    this.backdropTarget.classList.add("show");
    this.#modal(event.params.id)?.classList.add("show");
  }

  hideModals() {
    this.modalTargets.forEach((modal) => modal.classList.remove("show"));
    this.backdropTarget.classList.remove("show");
  }

  dismiss(event) {
    event.currentTarget.remove();
  }

  scrollTracks(event) {
    const tracks = document.querySelector(".tracks");

    if (!tracks || event.target.closest(".tracks, .reveal-modal")) return;

    tracks.scrollTop += event.deltaY;
    event.preventDefault();
  }

  #modal(id) {
    return this.modalTargets.find((modal) => modal.id === id);
  }
}
